export var getItem = function (key) {
    if (typeof window === 'undefined') {
        return undefined;
    }
    var value = localStorage.getItem(key);
    if (!value) {
        return undefined;
    }
    if (['undefined', 'null'].includes(value)) {
        return undefined;
    }
    try {
        value = JSON.parse(value);
    }
    catch (_a) { }
    return value;
};
export var setItem = function (key, value) {
    if (typeof window === 'undefined') {
        return;
    }
    localStorage.setItem(key, value);
};
export var removeItem = function (key) {
    if (typeof window === 'undefined') {
        return;
    }
    localStorage.removeItem(key);
};
